import React, { useState } from "react";
import { connect } from "react-redux";
import { Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import Countdown from "react-countdown";
import slugify from "slugify";
import { rendererOne } from "../count-down";

import { addToCart } from "../../../reducers/cart";
function ProductSix(props) {
  const {
    product,
    type = "product",
    // onAddToCart,
    addToCart,
    showQuickView,
  } = props;

  const [stock] = useState(product.quantity);
  const [quantity] = useState(1);
  const addToCartHandler = () => {
    // console.log("cell",quantity,stock,product.quantity)
    if (0 !== stock) addToCart({ ...product, quantity, stock });
  };

  const quickViewHandler = () => {
    // console.log("show quickview")
    showQuickView(product);
  };

  function toTop() {
    window.scroll({
      top: 0,
    });
  }
  return product ? (
    <div
      className={`product product-5 text-center ${
        0 === product.quantity ? "product-disabled" : ""
      }`}

    >
      <figure className="product-media"       >
        {product.condition ? (
          <span className="product-label label-new">{product.condition}</span>
        ) : (
          ""
        )}
        {product.top ? (
          <span className="product-label label-top">Top</span>
        ) : (
          ""
        )}
        {product.discount ? (
          <span className="product-label label-sale">Sale</span>
        ) : (
          ""
        )}
        {0 === stock ? (
          <span className="product-label label-out">Out Of Stock</span>
        ) : (
          ""
        )}
        <Link
          to={`/products/${
            product.seoMetaData?.slug || slugify(product.title.toLowerCase())
          }/`}
          className="product-image"
          onClick={toTop}
        >
          {/* <img
                            alt="product"
                            src={ `${process.env.PUBLIC_URL}/${product.images[0]}` }
                        /> */}

        
          {/* {product.images[1] ? (
            <span className="product-image-hover product-image">
              <img
                alt="product"
                src={product.images[1].childImageSharp.gatsbyImageData.src}
              />
            </span>
          ) : (
            ""
          )} */}
          <div className="product" style={{maxWidth:"150px",margin:"auto"}}>
          <GatsbyImage
            image={product.image.childImageSharp.gatsbyImageData}
            alt="product"
           
          />
          </div>
        </Link>
       
        {type !== "sidebar" && 0 < product.discount ? (
          <div className="product-countdown countdown-primary">
            <Countdown date={`2021-02-01T01:02:03`} renderer={rendererOne} />
          </div>
        ) : (
          ""
        )}

        <div className="product-action-vertical">
          <button
            className="btn-product-icon btn-quickview"
            title="Quick view"
            onClick={quickViewHandler}
          >
            <span>Quick views</span>
          </button>
        </div>

        <div className="product-action">
          <button
            className="btn-product btn-cart"
            disabled={quantity > stock}
            onClick={addToCartHandler}
          >
            <span>add to cart</span>
          </button>
        </div>
      </figure>

      <div className="product-body product-action-inner">
        <h3 className="product-title">
          <Link
            to={`/products/${
              product.seoMetaData?.slug || slugify(product.title.toLowerCase())
            }/`}
          >
            {product.title.substring(0, 26) + "..."}
          </Link>
        </h3>
        {Number(product.oldPrice) - Number(product.price) > 0 && (
          <label className="product-label2 label-rounded">
            Save{" "}
            <b>
              {(
                (100 * (Number(product.oldPrice) - Number(product.price))) /
                product.oldPrice
              ).toFixed(1)}
              %
            </b>
          </label>
        )}
        {0 < product.oldPrice && product.oldPrice > product.price ? (
          <div className="product-price">
            <span className="new-price">
              $
              {product.price.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </span>
            <span className="old-price">
              $
              {product.oldPrice.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </span>
          </div>
        ) : (
          <div className="product-price">
            $
            {product.price.toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </div>
        )}
        {/* {props.aspects && } */}
      </div>
    </div>
  ) : (
    ""
  );
}

export const mapStateToProps = (state, ownprops) => {
  return {};
};
const mapDispatchToProps = (dispatch) => ({
  addToCart: (item) => dispatch(addToCart(item)),
});
export default connect(mapStateToProps, mapDispatchToProps)(ProductSix);
